// TODO: palette used not correctly

const white = '#FFFFFF'
const orange = '#FE4602'

const palette = {
  primary: {
    light: '#fe6b34',
    main: orange,
    dark: '#b13101',
    contrastText: white,
  },
  secondary: {
    light: '#575c62',
    main: '#2E343B',
    dark: '#202429',
    contrastText: white,
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
  text: {
    primary: '#2E343B',
    secondary: '#2E343B',
    disabled: white,
  },
  divider: '#D2D5D8',
  background: {
    default: white,
  },
  action: {
    active: orange,
    hover: orange,
    disabled: white,
    disabledBackground: '#FFDACC',
  },
}

export default palette
